import { render, staticRenderFns } from "./SelectedAudience.vue?vue&type=template&id=4f079ee4&scoped=true&"
import script from "./SelectedAudience.vue?vue&type=script&lang=js&"
export * from "./SelectedAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f079ee4",
  null
  
)

export default component.exports